import React, { useId, useState } from 'react';

interface RandomCluePlacementOptionProps {
  checked: boolean;
  onChange: (value: boolean) => void;
}

export const RandomCluePlacementOption: React.FC<RandomCluePlacementOptionProps> = ({ checked, onChange }) => {
  const [showRules, setShowRules] = useState(false);
  const popupId = useId();

  return (
    <div className="random-clue-placement-option">
      <label className="checkbox-label">
        <input
          type="checkbox"
          checked={checked}
          onChange={event => onChange(event.target.checked)}
        />
        Random clue placement
      </label>
      <div className="random-clue-placement-info">
        <button
          type="button"
          className={`tooltip-button random-clue-placement-info-button${showRules ? ' active' : ''}`}
          onClick={() => setShowRules(current => !current)}
          aria-expanded={showRules}
          aria-controls={popupId}
          aria-label="Show random clue placement rules"
          title="Show random clue placement rules"
        >
          ?
        </button>
        {showRules && (
          <div
            id={popupId}
            className="random-clue-placement-popup"
            role="dialog"
            aria-label="Random clue placement rules"
          >
            <strong>Random clue placement</strong>
            <p>
              This game mode replaces each printed clue appearance location with a random eligible location:
            </p>
            <ul>
              <li>5% chance for a street</li>
              <li>25% chance for a stable location</li>
              <li>70% chance for an unstable location</li>
            </ul>
            <p>
              Closed locations and locations with open gates are excluded.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};
